import { Typography } from '@mui/material'
import React from 'react'

import { getAttackStageReadable } from 'components/attacks/utils/attack-stages'

export const ActiveAttackStatusText: React.FC<{
  attackStage?: string
  isHalting?: boolean
}> = ({ attackStage, isHalting }) => {
  if (isHalting) {
    return <span>Halting...</span>
  }

  return (
    <Typography data-test-status variant="caption">
      {getAttackStageReadable(attackStage)}
      ...
    </Typography>
  )
}
